import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import AppSwitcherContent from './components/AppSwitcherContent';
import appList from '../../../../config/apps';
import { ActivationModal } from '../Activation/ActivationModal';
import { Icon } from '../../../../';
import { Layout as IntegratedExperienceLayout } from './components/IntegratedExperience/Layout';
import FeedbackModal from './components/IntegratedExperience/FeedbackModal';
import { PRODUCT_STATUS } from './productsStatus';
import { withNavDropdownEvents, NavDropdown } from '../NavDropdown';
export var AppSwitcherComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(AppSwitcherComponent, _React$Component);

  var _super = _createSuper(AppSwitcherComponent);

  function AppSwitcherComponent() {
    var _this;

    _classCallCheck(this, AppSwitcherComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onLinkClick", function (product, productStatus) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          onSelectProduct = _this$props.onSelectProduct,
          features = _this$props.features;
      var isCrossActivationEnabled = features && features.crossActivation;

      if (typeof onSelectProduct === 'function' && isCrossActivationEnabled) {
        onSelectProduct(product, productStatus);
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onShowFeedbackModal", function (onFeedbackComplete) {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          onShowFeedbackModal = _this$props2.onShowFeedbackModal,
          features = _this$props2.features;
      var isIntegratedExperience = features && features.integratedExperience;

      if (typeof onShowFeedbackModal === 'function' && isIntegratedExperience) {
        onShowFeedbackModal(onFeedbackComplete);
      }

      if (typeof onClose === 'function') {
        onClose();
      }
    });

    return _this;
  }

  _createClass(AppSwitcherComponent, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          currentProduct = _this$props3.currentProduct,
          _this$props3$environm = _this$props3.environment,
          environment = _this$props3$environm === void 0 ? 'production' : _this$props3$environm,
          features = _this$props3.features,
          inverted = _this$props3.inverted,
          swicusOrgId = _this$props3.swicusOrgId,
          onReloadHandler = _this$props3.onReloadHandler,
          onShowFeedbackModal = _this$props3.onShowFeedbackModal,
          rest = _objectWithoutProperties(_this$props3, ["currentProduct", "environment", "features", "inverted", "swicusOrgId", "onReloadHandler", "onShowFeedbackModal"]);

      var isIntegratedExperience = features && features.integratedExperience;
      return /*#__PURE__*/React.createElement(NavDropdown, _extends({
        className: "cloud-ui-app-switcher",
        inverted: inverted,
        label: /*#__PURE__*/React.createElement("div", {
          className: "nav-icon-wrapper",
          "data-qa": "app-switcher"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "app-switcher"
        })),
        pinned: true,
        position: "bottom right",
        tooltip: "SolarWinds Application Management Suite"
      }, rest), isIntegratedExperience ? /*#__PURE__*/React.createElement(IntegratedExperienceLayout, {
        currentProduct: currentProduct,
        environment: environment,
        features: features,
        inverted: inverted,
        onLinkClick: this.onLinkClick,
        onReloadHandler: onReloadHandler,
        swicusOrgId: swicusOrgId,
        onShowFeedbackModal: this.onShowFeedbackModal
      }) : /*#__PURE__*/React.createElement(AppSwitcherContent, {
        currentProduct: currentProduct,
        environment: environment,
        features: features,
        products: appList,
        onLinkClick: this.onLinkClick,
        swicusOrgId: swicusOrgId,
        inverted: inverted
      }));
    }
  }]);

  return AppSwitcherComponent;
}(React.Component);
var AppSwitcherWithEvents = withNavDropdownEvents(AppSwitcherComponent);

var AppSwitcher = /*#__PURE__*/function (_React$Component2) {
  _inherits(AppSwitcher, _React$Component2);

  var _super2 = _createSuper(AppSwitcher);

  function AppSwitcher() {
    var _this2;

    _classCallCheck(this, AppSwitcher);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isModalOpen: false,
      isFeedbackModalOpen: false,
      product: '',
      productStatus: ''
    });

    _defineProperty(_assertThisInitialized(_this2), "openModalForProduct", function (product, productStatus) {
      var statusesForModal = [PRODUCT_STATUS.ACCESS_NEEDED, PRODUCT_STATUS.CAN_ACTIVATE];

      if (product && statusesForModal.includes(productStatus)) {
        _this2.setState({
          isModalOpen: true,
          product: product,
          productStatus: productStatus
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "closeModal", function () {
      _this2.setState({
        isModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "openFeedbackModal", function (onFeedbackComplete) {
      _this2.setState({
        onFeedbackComplete: onFeedbackComplete
      });

      _this2.setState({
        isFeedbackModalOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "closeFeedbackModal", function () {
      _this2.setState({
        isFeedbackModalOpen: false
      });
    });

    return _this2;
  }

  _createClass(AppSwitcher, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          swicusOrgId = _this$props4.swicusOrgId,
          _this$props4$environm = _this$props4.environment,
          environment = _this$props4$environm === void 0 ? 'production' : _this$props4$environm,
          currentProduct = _this$props4.currentProduct;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppSwitcherWithEvents, _extends({}, this.props, {
        onSelectProduct: function onSelectProduct(product, productStatus, features) {
          return _this3.openModalForProduct(product, productStatus, features);
        },
        onShowFeedbackModal: this.openFeedbackModal
      })), /*#__PURE__*/React.createElement(ActivationModal, {
        swicusOrgId: swicusOrgId,
        environment: environment,
        isOpen: this.state.isModalOpen,
        onClose: this.closeModal,
        targetProduct: this.state.product,
        originProduct: currentProduct,
        productStatus: this.state.productStatus
      }), /*#__PURE__*/React.createElement(FeedbackModal, {
        swicusOrgId: swicusOrgId,
        environment: environment,
        isOpen: this.state.isFeedbackModalOpen,
        onFeedbackComplete: this.state.onFeedbackComplete,
        onClose: this.closeFeedbackModal,
        source: "combinednav"
      }));
    }
  }]);

  return AppSwitcher;
}(React.Component);

export default AppSwitcher;